export default __webpack_public_path__ + "static/media/salami.9d242844.png";